
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 306.09 269.83"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 20v229.83a20 20 0 0020 20h137.32c103.77 0 148.77-58.12 148.77-135.18C306.09 57.89 261.09 0 157.32 0H20A20 20 0 000 20z"}}),_c('path',{attrs:{"d":"M157.29 251.46H37.86a19.22 19.22 0 01-19.2-19.2V37.57a19.22 19.22 0 0119.2-19.2h119.43c113.27 0 130.19 72.85 130.19 116.28 0 75.35-46.24 116.81-130.19 116.81zM37.86 24.77a12.82 12.82 0 00-12.81 12.8v194.69a12.82 12.82 0 0012.81 12.8h119.43c79.82 0 123.79-39.21 123.79-110.41 0-95.6-77.56-109.88-123.79-109.88z"}}),_c('path',{attrs:{"fill":"#00b0f0","d":"M91.88 56.43V226.2h73.9c67.14 0 96.25-37.94 96.25-91.46 0-51.27-29.11-91.11-96.25-91.11h-61.1a12.8 12.8 0 00-12.8 12.8z"}}),_c('path',{attrs:{"fill":"#fff","d":"M168.27 111.86l16.93 27.21h.11v-27.21h8.35v40.55h-8.92l-16.87-27.15h-.11v27.15h-8.35v-40.55h8.86zM142.51 111.86h8.92v40.55h-8.92zM134.91 123.11a17.26 17.26 0 00-3.87-6.25 15.64 15.64 0 00-5.85-3.75 20.9 20.9 0 00-7.29-1.25h-17.5v40.55h17.5a19.43 19.43 0 008.09-1.56 16.14 16.14 0 005.74-4.29 18 18 0 003.43-6.47 28 28 0 001.14-8.18 25.44 25.44 0 00-1.39-8.8zm-8.38 15.33a10.52 10.52 0 01-2.27 3.78 8.28 8.28 0 01-3.24 2.07 11.36 11.36 0 01-3.75.63h-8v-25.56h6.36a14.51 14.51 0 015.54.93 8.83 8.83 0 013.61 2.7 11 11 0 012 4.23 24.14 24.14 0 01.59 5.54 16.54 16.54 0 01-.84 5.68z"}}),_c('path',{attrs:{"d":"M58.48 161.57a14.17 14.17 0 0114.17 14.17v50.46a28.35 28.35 0 01-28.35-28.35v-22.11a14.17 14.17 0 0114.18-14.17z"}}),_c('circle',{attrs:{"cx":"58.48","cy":"132.1","r":"18.71"}})])
          )
        }
      }
    